import React, { Component } from 'react';
import { iconList } from '../../../Images/ManualCallSVG';
import { search } from '../../../Images/Images';
import { closeSvg } from '../../../Images/GenericSVG';
import { connect } from 'react-redux';
import { Singleton } from '../../../js/Singleton';
import { insertWindow, removeWindow } from '../../../redux/actions/A_draggable_windows_controller';
import { DRAGGABLE_WINDOWS } from '../../../constants.js';
import { CUSTOM_COMPONENTS } from '../../../js/customElements/customComponents';
import _ from 'lodash';

class TemplatesWhatsapp extends Component {
	constructor(props) {
		super(props);
		this.language = new Singleton();
		this.state = {
			searchTemplate: '',
			templatesList: _.get(this.props.objProps.propsData, 'templatesList', []),
			templatesFiltered: [],
			selectedTemplate: {}
		};
		this.loading = false;
		this.setTemplateWhatsapp = _.get(this.props.objProps, 'setTemplateWhatsapp', false);
	}

	componentDidMount() {
		this.setState({ templatesFiltered: this.state.templatesList });
	}

	onSearchTemplates(e) {
		this.setState({ searchTemplate: e });
		const newTemplatesList = this.state.templatesList.filter(template => template.TemplateName.toLowerCase().startsWith(e.toLowerCase()));
		this.setState({ templatesFiltered: newTemplatesList });
	}

	onSelectTemplate(template) {
		this.setState({ selectedTemplate: template });
	}

	onSubmit() {
		this.setTemplateWhatsapp(this.state.selectedTemplate);
		this.props.removeWindow(DRAGGABLE_WINDOWS.TEMPLATES_WHATSAPP);
	}

	render() {
		return (
			<div className='templatesWhatsapp' onClick={() => this.props.goTopZ(this.props.id)}>
				{CUSTOM_COMPONENTS['draggableHeader'](
					iconList,
					this.language.getText('GUIManualMessagetemplates-title'),
					() => {
						this.props.removeWindow(DRAGGABLE_WINDOWS.TEMPLATES_WHATSAPP);
					},
					{
						iconHeader: 'iconListHeader'
					}
				)}
				<div className={'visibleWindow'}>
					<div className={`templatesWhatsappDetail`}>
						<div className="templatesList">
						{CUSTOM_COMPONENTS['inputDelete'](
								this.state.searchTemplate,
								e => this.onSearchTemplates(e),
								'searchContainer ' + (this.loading ? 'loading' : ''),
								'txtSearch',
								'cleanButton',
								closeSvg,
								false,
								search,
								'iconSearch',
								this.language.getText('GUIManualMessagesearch-template')
							)}
						<div className='templatesListItems'>
							{this.state.templatesFiltered.map((template) => {
								return (
									<div className={`templateOption ${this.state.selectedTemplate.TemplateName === template.TemplateName ? 'selected':''}`} onClick={() => this.onSelectTemplate({TemplateName: template.TemplateName, Body: template.Body})} key={template.TemplateId}>
										<p className='templateOptionTitle'>{template.TemplateName}</p>
										<p className='templateOptionContent'>{template.Body}</p>
									</div>
								);
							})}
						</div>
						</div>
						<div className='templatesView'>
							<p className='templatesViewTitle'>{this.language.getText('GUIManualMessagetemplate-preview')}</p>
							<div className='templatesViewContainer'>
								{Object.keys(this.state.selectedTemplate).length !== 0 ? (
									<div className='templateSelectedView'>
										<p className='templatesViewContent'>{this.state.selectedTemplate.Body}</p>
									</div>
								):null}
							</div>
						</div>
					</div>
					<div className={`templatesWhatsappFooter`}>
						<div
							className={'setTemplateWhatsapp ' + (Object.keys(this.state.selectedTemplate).length === 0 ? 'disabled' : '')}
							onClick={() => this.onSubmit()}>
							{this.language.getText('GUIManualMessageselect-commit')}
						</div>
					</div>
				</div>
			</div>
		);
	}
}
function mapDispatchToProps(dispatch) {
	return {
		insertWindow: (dragWindow, closeComponentIfOpen) => {
			dispatch(insertWindow(dragWindow, closeComponentIfOpen));
		},
		removeWindow: iDdragComponent => {
			dispatch(removeWindow(iDdragComponent));
		}
	};
}
export default TemplatesWhatsapp = connect(null, mapDispatchToProps)(TemplatesWhatsapp);



// WEBPACK FOOTER //
// ./src/components/workSpace/floatingWindows/TemplatesWhatsapp.jsx